import React from 'react'
import { IndexLayout } from '../components/index-layout/IndexLayout'
import '../styles/pages/404.scss'

const NotFoundPage = () => (
  <IndexLayout>
    <div className="la-not-found-box">
      <strong>Page Not Found</strong>
      <p>
        We&apos;re sorry. The page you are looking for cannot be found.
        <br />
        Please select product you&apos;re interested in from the top menu or use search to find
        information you need.
      </p>
    </div>
  </IndexLayout>
)

export default NotFoundPage
